import React, { useState, useEffect } from 'react';
import LeftBarData from './LeftBarData';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const LeftBar = ({ onPageChange, onNodeSelect, onChildSelect, onDrop1Change,toggleLeftbar, isLeftbarVisible }) => {
  const [activeLink, setActiveLink] = useState(null);
  const [grandchildactiveLink, setGrandchildactiveLink] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [activeMenuItem, setActiveMenuItem] = useState(LeftBarData[0]?.key || null);
  const [expandedItems, setExpandedItems] = useState([]);

  const handleLinkClick = (page, child = 0, nodeLabel, childLabel, innerchild=0) => {
    onPageChange(page * 100 + child*10+innerchild);
    setActiveLink(`${page}-${child}`)
    setGrandchildactiveLink(`${page}-${child}-${innerchild}`)
    onNodeSelect(nodeLabel);
    onChildSelect(childLabel);
  };

  const [drop1, setDrop1] = useState('New');
  const [drop2, setDrop2] = useState('Website');
  const [drop3, setDrop3] = useState('E-Commerce');
  const DropChng1 = (selectedOption) => { setDrop1(selectedOption); };
  const DropChng2 = (selectedOption) => { setDrop2(selectedOption); };
  const DropChng3 = (selectedOption) => { setDrop3(selectedOption); };

  useEffect(() => {
    onDrop1Change(drop1 + ' ' + drop2 + ' for the ' + drop3 + ' Industry');
  }, [drop1, drop2, drop3, onDrop1Change]);

  const handleToggleExpand = (pageIndex) => {
    setExpandedItems(prevExpandedItems => {
      const index = prevExpandedItems.indexOf(pageIndex);
      if (index !== -1) {
        // Item is expanded, collapse it
        return [...prevExpandedItems.slice(0, index), ...prevExpandedItems.slice(index + 1)];
      } else {
        // Item is collapsed, expand it
        return [...prevExpandedItems, pageIndex];
      }
    });
  };
  const isExpanded = (pageIndex) => {return expandedItems.includes(pageIndex);  };


  return (
    <div id="left-bar" className={`${isLeftbarVisible ? '' : 'leftbar-hidden'}`}>

      {/* Logo */}
      <div className="logo w-100 text-center p-2">
        <img src="/img/splash.png" width="140" /> <br />
        <span className='fw-bold font-primary fs-5 pt-2 d-inline-block '>Double Diamond Design Process</span>
      </div>

      {/* Dropdown */}
      <div className="dropdown-container px-2 border-top py-2 text-center bg-theme-accent text-white para flex-center justify-content-between mb-1 ">
        <span>Hi <b>Mr. John</b> (Chanel.com)</span>
        <a className='text-white' href='/'><ExitToAppIcon/></a>        
      </div>

      {/* <div className="para dropdown-container px-2 d-flex align-items-center justify-content-evenly border borer-1 border-start-0 border-end-0 py-2 ">
        <div className=' '>
          <label htmlFor="projectType" className='opacity-75 pb-1 '>Type : </label><br />
          <select className='p-1' id="projectType" onChange={(e) => DropChng1(e.target.value)}>
            <option value="New">New</option>
            <option value="Revamp">Revamp</option>

          </select>
        </div>

        <div className=' '>
          <label htmlFor="projectType" className='opacity-75 pb-1'>Project : </label><br />
          <select className='p-1' id="projectType" onChange={(e) => DropChng2(e.target.value)}>
            <option value="Website">Website</option>
            <option value="Web App">Web App</option>
            <option value="Mobile App">Mobile App</option>
          </select>
        </div>
        <div>
          <label htmlFor="projectType" className='opacity-75 pb-1'>Industry : </label><br />
          <select className='p-1' id="projectType" onChange={(e) => DropChng3(e.target.value)}>
            <option value="E-Commerce">E-Commerce</option>
            <option value="FinTech">FinTech</option>
            <option value="Healthtech">Healthtech</option>
            <option value="EdTech">EdTech</option>
            <option value="Travel">Travel</option>
          </select>
        </div>
      </div> */}

      <ul>
        {LeftBarData.map((node, pageIndex) => {
          const FindRootClicked = pageIndex + '-0';
          const isNodeActive = activeLink === `${pageIndex}`;
          const isChildActive = node.children.some((child, childIndex) => {
            if (typeof child === 'object') {
              return child.children.some((innerChild, innerChildIndex) => {
                return (
                  activeLink === `${pageIndex}-${childIndex + 1}` ||
                  grandchildactiveLink === `${pageIndex}-${childIndex + 1}-${innerChildIndex + 1}`
                );
              });
            } else {
              return activeLink === `${pageIndex}-${childIndex + 1}`;
            }
          });

          return (
            <li className={`li-parent`}>
              <a
                href={`#${node.label.toLowerCase()}`}
                className={`anchor-parent d-flex align-items-cetner justify-content-between ${FindRootClicked === activeLink ? 'active' : ''} ${pageIndex === 0 && !activeLink ? 'active' : ''} ${isNodeActive || isChildActive ? 'active' : ''}`}                                
                onClick={() => {handleLinkClick(pageIndex, 0, node.label, ''); handleToggleExpand(pageIndex); }}
              >
                <span                     
                >{node.label}</span>
                {node.children.length > 0 && (
                  <span className="toggle-expand" >
                    <i className={`bi ${isExpanded(pageIndex) ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                  </span>
                )}
              </a> 
              {node.children.length > 0 && (
                <ul style={{ display: isExpanded(pageIndex) ? 'block' : 'none' }} className={FindRootClicked === activeLink ? 'active' : ''}>
                  {node.children.map((child, childIndex) => (
                    <li key={childIndex} >
                      
                      {typeof child === 'object' ? (
                        <React.Fragment>
                          <a
                            onClick={() => handleLinkClick(pageIndex, childIndex + 1, node.label, child.label)}
                            href={`#${node.label.toLowerCase()}-child-${childIndex + 1}`}
                            className={activeLink === `${pageIndex}-${childIndex + 1}` ? 'active' : ''}
                          >
                            {childIndex + 1}. {child.label}
                            {/* ==={pageIndex}, {childIndex+1}, {node.label}, {child.label} */}
                          </a>
                          <ul>
                            {child.children.map((innerChild, innerChildIndex) => (
                              <li key={innerChildIndex} >
                                <a
                                  onClick={() => handleLinkClick(pageIndex, childIndex + 1, node.label, innerChild, innerChildIndex + 1)}
                                  href={`#${child.label.toLowerCase()}-child-${innerChildIndex + 1}`}
                                  className={grandchildactiveLink === `${pageIndex}-${childIndex + 1}-${innerChildIndex + 1}` ? 'active' : ''}
                                >
                                 <span className={'d-flex justify-content-start align-items-top '}>
                                 <span className={'d-inline-block ps-4'}>&#9656;</span> {innerChild}  
                                </span> 
                                </a>
                              </li>
                            ))}
                          </ul>
                        </React.Fragment>
                      ) : (
                        <a
                          onClick={() => handleLinkClick(pageIndex, childIndex + 1, node.label, child)}
                          href={`#${node.label.toLowerCase()}-child-${childIndex + 1}`}
                          className={activeLink === `${pageIndex}-${childIndex + 1}` ? 'active' : ''}
                        >
                          {childIndex + 1}. {child}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LeftBar;